export const STRIPE_PK = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
export const STRIPE_PRICES = {
  starter: 'price_1TFhCKAheu8cY3dwZbbC2Wjz',
  plus: 'price_1TFhD7Aheu8cY3dwEzERYL3I',
  family: 'price_1TFhDiAheu8cY3dwrDz0y8OA',
  plusAnnual: 'price_1TFhEUAheu8cY3dwaooW4F93',
  familyAnnual: 'price_1TFhFDAheu8cY3dwOwhPJoJN'
};
